import { createTheme } from "@mui/material/styles";

// ASTT-7319: extracted from identical createTheme() calls that were
// duplicated independently in TrainingNotes.js and HandOffReport.js.
// Both files now import this single instance instead -- any future
// palette change only needs to happen here, not in every file that
// happens to need DTR/Hand-off styling.
const dtrTheme = createTheme({
  palette: {
    primary: {
      main: "#3299FF",
    },
    action: {
      disabled: "#636362",
    },
  },
});

export default dtrTheme;
